 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		92: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		92: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360Plus","45":"EarlyProtect360Plus.Dashboard","46":"EarlyProtect360Plus.Details","47":"FamilyProtect360","48":"FamilyProtectLiteWithUpgrade","49":"FilipinoBond","50":"FlashPayShieldWithUpgrade","51":"FraudProtect360","52":"HIProtect360Protect360","53":"HomeProtect360","54":"HomeProtectLite","55":"HomeSafe","56":"HomeStarterKit","57":"InternalDemoCookie","58":"KeymanProtect360","59":"KeymanProtect360.Dashboard","60":"KeymanProtect360.Details","61":"LeadForm","62":"Loan Protect 360 Renewal","63":"LoanProtect360","64":"LoanProtect360.Dashboard","65":"LoanProtect360.Details","66":"MaidProtect360","67":"MotoringCardShieldWithUpgrade","68":"Motorshow2020","69":"PartnerProgram","70":"PhoneProtect360","71":"PowerAgentPortal","72":"Prestige","73":"Prestige.Secured","74":"PublicHousingAssured","75":"ReviewUs","76":"SBSTPAProtectLite","77":"SBSTPAProtectPlus","78":"SBSTTravelInsurance","79":"SOA","80":"SimplyGo","81":"SingaporeTravelPass","82":"Touristcard","83":"TravelAssured","84":"TravelAssuredPlus","85":"TravelProtect360","86":"TravelProtect360Plus","87":"cileadform","88":"currencyconverter","89":"freehomeinsurance","91":"motorshow","93":"transferprotect360pro","94":"vCashCard","95":"weather"}[chunkId]||chunkId) + "." + {"0":"ddc8cdad","1":"18c86dce","2":"04b1de46","3":"4e0870df","4":"1a2f8f9d","5":"fde96dd9","6":"bc2457b7","7":"41bbe130","8":"8e3086b8","9":"7e459b07","10":"1e8d0ea1","11":"fb752182","12":"e237aa75","13":"f96f7bdf","14":"8c8b00f0","15":"dd899c49","16":"d6a6328a","17":"3ea530ac","18":"a078d696","19":"aa1a06ed","20":"20705574","21":"114768cf","22":"b914031f","23":"238fc52d","24":"b9bb6492","25":"b8ec722f","26":"750ca370","27":"1d7781ee","28":"c842df62","29":"5289352b","30":"bf7c0470","31":"f4a62b1e","32":"eaedb89f","33":"d1e181b6","34":"db868fc8","35":"9e524c70","36":"08f16977","37":"09da0ddc","38":"9d50c65b","39":"ec9e3742","40":"f9384bdd","41":"d85d84b0","42":"9e442241","43":"4ab020b6","44":"49784438","45":"69cc7ffa","46":"d3fc6754","47":"b13173c4","48":"6ee33248","49":"85a709e6","50":"54ecdef9","51":"3fbce911","52":"d9cee065","53":"08de0e71","54":"981bc83d","55":"2575451f","56":"d578feb0","57":"dd1e6bd5","58":"0e09faa4","59":"1f16c36c","60":"eaa09721","61":"17fc79a9","62":"ba8be0aa","63":"e1df42de","64":"bee73a2f","65":"c494626b","66":"933485f0","67":"f5fc31d4","68":"9018f0dd","69":"6d5ccd36","70":"6c0b94d4","71":"46d2ed7a","72":"a6f6bb27","73":"5c20579c","74":"0f7b7e2e","75":"9d621ef0","76":"f79b4cf6","77":"bc7e12fa","78":"b2185b5c","79":"e4f3153b","80":"7791e718","81":"d45582fc","82":"167075de","83":"040fa65d","84":"df645f67","85":"a1391122","86":"af967a39","87":"4b394da7","88":"82770a8e","89":"063f961b","91":"dce5415f","93":"a3a789e4","94":"755fa546","95":"d5a0ae11","97":"fbf41266","98":"65455fef","99":"93fe2021","100":"51facfb2","101":"9c7ab60d","102":"1102c038","103":"1ef67525","104":"2b6bbcd7","105":"6a86f88b","106":"b379584d","107":"aa124a98","108":"40da479b","109":"9167f1cb","110":"6710159a","111":"07bb2fa9","112":"0aca5af4","113":"07f5f277","114":"229584b9","115":"47bf0e96","116":"f153bd70","117":"905b3068","118":"0f3671d8","119":"a361c83e","120":"f1388220","121":"15046c17","122":"d2c6d678","123":"bf103a10","124":"4c0aff3c","125":"2839aa58","126":"d0edfe1b","127":"0eeae0e8","128":"6c9e073b","129":"355c7d8f","130":"73ee4942","131":"c5c5c1b9","132":"f30c84a5","133":"2a9696ee","134":"86d8a01c","135":"e2abd5a9","136":"d3eb0fd2","137":"b454cf13","138":"7b4e2ee1","139":"a6b954ac","140":"c1da8bab","141":"3a9b88d9","142":"1c37edd3","143":"ac2fba46","144":"97109134","145":"3d9622e9","146":"fc1be82e","147":"e9e30321","148":"8ca785a7","149":"7e59e8e0","150":"8d5f57c9","151":"a542b10a","152":"afad0d1c","153":"e4b73fc6","154":"43c370c8","155":"9d5acd0f","156":"6373e20f","157":"15e027ef","158":"72c248b0","159":"af51f4d7","160":"90db7510","161":"d4756771","162":"826aa64d","163":"d986d759","164":"5bebfe3f","165":"6e4d1a27","166":"662e4718","167":"212a0db7","168":"cdffe170","169":"e0a8039a","170":"7331682a","171":"28b46a1a","172":"e2478535","173":"fe522ed7","174":"78e0e21f","175":"bcc615f1","176":"0e95d624","177":"de47b97d","178":"5feeacb9"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"23":1,"25":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"58":1,"61":1,"66":1,"67":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"91":1,"93":1,"94":1,"95":1,"98":1,"99":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"113":1,"117":1,"121":1,"122":1,"126":1,"127":1,"131":1,"132":1,"133":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"140":1,"141":1,"142":1,"143":1,"144":1,"156":1,"157":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360Plus","45":"EarlyProtect360Plus.Dashboard","46":"EarlyProtect360Plus.Details","47":"FamilyProtect360","48":"FamilyProtectLiteWithUpgrade","49":"FilipinoBond","50":"FlashPayShieldWithUpgrade","51":"FraudProtect360","52":"HIProtect360Protect360","53":"HomeProtect360","54":"HomeProtectLite","55":"HomeSafe","56":"HomeStarterKit","57":"InternalDemoCookie","58":"KeymanProtect360","59":"KeymanProtect360.Dashboard","60":"KeymanProtect360.Details","61":"LeadForm","62":"Loan Protect 360 Renewal","63":"LoanProtect360","64":"LoanProtect360.Dashboard","65":"LoanProtect360.Details","66":"MaidProtect360","67":"MotoringCardShieldWithUpgrade","68":"Motorshow2020","69":"PartnerProgram","70":"PhoneProtect360","71":"PowerAgentPortal","72":"Prestige","73":"Prestige.Secured","74":"PublicHousingAssured","75":"ReviewUs","76":"SBSTPAProtectLite","77":"SBSTPAProtectPlus","78":"SBSTTravelInsurance","79":"SOA","80":"SimplyGo","81":"SingaporeTravelPass","82":"Touristcard","83":"TravelAssured","84":"TravelAssuredPlus","85":"TravelProtect360","86":"TravelProtect360Plus","87":"cileadform","88":"currencyconverter","89":"freehomeinsurance","91":"motorshow","93":"transferprotect360pro","94":"vCashCard","95":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"86c9f98d","23":"d30bc41f","24":"31d6cfe0","25":"d33f62d9","26":"31d6cfe0","27":"31d6cfe0","28":"58058363","29":"31d6cfe0","30":"05f863ac","31":"ddf1f108","32":"04bc7233","33":"ddf1f108","34":"d33f62d9","35":"31d6cfe0","36":"31d6cfe0","37":"0e4fba13","38":"978e5247","39":"31d6cfe0","40":"ac3f861f","41":"0e4fba13","42":"5d27deaa","43":"31d6cfe0","44":"58058363","45":"31d6cfe0","46":"31d6cfe0","47":"ddf1f108","48":"0e4fba13","49":"ddf1f108","50":"0e4fba13","51":"ddf1f108","52":"ddf1f108","53":"471a3a57","54":"471a3a57","55":"471a3a57","56":"0e4fba13","57":"31d6cfe0","58":"58058363","59":"31d6cfe0","60":"31d6cfe0","61":"dd9a60e3","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"14284125","67":"0e4fba13","68":"31d6cfe0","69":"8b647349","70":"471a3a57","71":"716aad65","72":"2fc531d7","73":"cdec5a50","74":"471a3a57","75":"31d6cfe0","76":"39dd3a27","77":"e81d10c5","78":"86c9f98d","79":"d33f62d9","80":"98c15efc","81":"2e8fdc12","82":"7986da5d","83":"86c9f98d","84":"86c9f98d","85":"2e8fdc12","86":"86c9f98d","87":"22b92479","88":"7b4f34de","89":"0e4fba13","91":"49234f01","93":"14284125","94":"94b03ce8","95":"23255cb6","97":"31d6cfe0","98":"cce35a68","99":"440606be","100":"31d6cfe0","101":"2d576837","102":"166c8acc","103":"db5d06da","104":"f93319e8","105":"f93319e8","106":"72c6f688","107":"72c6f688","108":"72c6f688","109":"f93319e8","110":"72c6f688","111":"31d6cfe0","112":"31d6cfe0","113":"6f6df1fe","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"6f6df1fe","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"6f6df1fe","122":"6f6df1fe","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"4b48318c","127":"4b48318c","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"4b48318c","132":"4b48318c","133":"4b48318c","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"4b48318c","141":"4b48318c","142":"4b48318c","143":"4b48318c","144":"4b48318c","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"5fe6802c","157":"5fe6802c","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","178":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
